export enum InfluencerState {
  Unknown = 'Unknown',
  Before = 'Before',
  // Countdown has elapsed but no live yet.
  WaitingToStart = 'WaitingToStart',
  During = 'During',
  // No need for a state for waiting for replays.
  // If we don't have replays, we just don't show that widget.
  After = 'After',
}

const chooseInfluencerState = ({
  isInfluencerLive,
  latestLiveTime,
  nextLiveTime,
  nowTime,
}: {
  isInfluencerLive: boolean;
  latestLiveTime?: number;
  nextLiveTime: number | null;
  nowTime: number;
}): InfluencerState => {
  try {
    if (!nextLiveTime) return InfluencerState.After;

    const isBeforeEvent = nextLiveTime > nowTime;
    const latestLiveIsBeforeNextLive =
      !latestLiveTime || latestLiveTime < nextLiveTime;

    if (isInfluencerLive) return InfluencerState.During;

    if (isBeforeEvent) {
      return InfluencerState.Before;
    }

    if (!isBeforeEvent && !isInfluencerLive && latestLiveIsBeforeNextLive) {
      return InfluencerState.WaitingToStart;
    }

    if (!isBeforeEvent && !isInfluencerLive && !latestLiveIsBeforeNextLive) {
      return InfluencerState.After;
    }
  } catch {
    return InfluencerState.Unknown;
  }

  return InfluencerState.Unknown;
};

export default chooseInfluencerState;
